<template>
<div class="layer-project" data-project-name="hos"><!-- Project Name -->
    <div class="layer-project-detail">
        <!-- Page Contents -->
        <section class="project-visual">
            <div>
                <h1 class="project-tit">
                    <span class="txt-wrap"><span class="break-m hmc">HMC</span> <span>Online</span></span> <span class="txt-wrap">Direct <span class="break-m">Sale Platform</span></span>
                </h1>
                <a href="https://www.hyundai.com/sg" class="link" target="_blank">www.hyundai.com/sg</a>
            </div>
        </section>
        <!-- Details [s] -->

        <!-- Details [s] -->
        <section class="project-overview">
            <div class="inner-section">
                <h2 class="project-overview-tit">Overview</h2>
                <p class="project-overview-txt">전 세계적으로 진출하는 글로벌 기업인 현대자동차그룹에서 글로벌 가이드를 적용하여 작업한 마스터 플랫폼 프로젝트입니다. 각 나라별 사이트를 통일된 가이드를 기준으로 현대자동차그룹의 아이덴티티로 <br>정리 및 개선하여 글로벌 기업으로서의 현대자동차의 기업이미지와 사용자 경험의 퀄리티를 상향시키고 있습니다.</p>
                <div class="project-overview-diagram">
                    <p class="diagram01">Global Design Guide <br>Responsive Website</p>
                    <p class="diagram02">
                        <ul>
                            <li>Global Corporate <br>Identity</li>
                            <li>Improved <br>UI/UX Design</li>
                            <li>User <br>convenience</li>
                        </ul>
                    </p>
                    <p class="diagram03">Hyundai Motor <br>Company <span>Master Platform</span></p>
                </div>
            </div>
        </section>
        <!-- Details [e] -->
        <section class="section full master-platform">
            <div class="inner-section">
                <strong class="project-subtit">
                    <span>Hyundai Motor <br>Company <strong>New Master <br>Platform</strong></span>
                </strong>
                <p>Hyundai Motor Company Identity</p>
            </div>
            <div class="img">
                <img src="" alt="" data-src="/static/img/project-detail/hos/new-master-platform@m.jpg">
            </div>
        </section>
        <section class="section pc-web">
            <div class="inner-section">
                <div class="head">
                    <strong class="project-subtit">PC Web</strong>
                    <p class="cont-desc">현대자동차의 메인 비주얼을 강조하여 브랜드 제품에 대한 흥미를 유발하고, <br>넓은 화면 사용과 심플한 아이콘을 통해 직관적으로 작업했습니다.</p>
                </div>
                <div class="cont">
                    <div class="img">
                        <img src="" alt="" data-src="/static/img/project-detail/hos/pc-web-img02@m.png">
                    </div>
                    <div class="swiper-wrap">
                        <div class="swiper-container">
                            <ul class="swiper-wrapper">
                                <li class="swiper-slide"><div><img src="" alt="" data-src="/static/img/project-detail/hos/pc-web-img03-01@m.png"></div></li>
                                <li class="swiper-slide"><div><img src="" alt="" data-src="/static/img/project-detail/hos/pc-web-img03-02@m.png"></div></li>
                                <li class="swiper-slide"><div><img src="" alt="" data-src="/static/img/project-detail/hos/pc-web-img03-03@m.png"></div></li>
                                <li class="swiper-slide"><div><img src="" alt="" data-src="/static/img/project-detail/hos/pc-web-img03-04@m.png"></div></li>
                                <li class="swiper-slide"><div><img src="" alt="" data-src="/static/img/project-detail/hos/pc-web-img03-05@m.png"></div></li>
                                <li class="swiper-slide"><div><img src="" alt="" data-src="/static/img/project-detail/hos/pc-web-img03-06@m.png"></div></li>
                            </ul>
                            <!-- Add Pagination -->
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section tablet-web">
            <div class="inner-section">
                <strong class="project-subtit">Tablet Web</strong>
                <p class="cont-desc">현대자동차의 마스터 플랫폼의 <br>태블릿 레이아웃은 부드러운 화면 전환을 위하여 <span>웹 또는 모바일과 동일한 구성으로 작업 했습니다.</span></p>
            </div>
            <div class="img-area">
                <div class="img">
                    <img src="" alt="" data-src="/static/img/project-detail/hos/tablet-web-img@m.png">
                </div>
            </div>
        </section>
        <section class="section mobile-web">
            <div class="inner-section">
                <strong class="project-subtit">Mobile Web</strong>
                <p class="cont-desc">웹 사이트와 유사한 UI/UX를 유지하면서 모바일에 최적화된 레이아웃으로 <br>모바일에서도 편리하게 사용할 수 있도록 반응형 웹으로 작업했습니다.</p>
            </div>
            <div class="img">
                <img src="" alt="" data-src="/static/img/project-detail/hos/mobile-web-img@m.png">
            </div>
        </section>
        <section class="section global-site-building">
            <div class="inner-section">
                <strong class="project-subtit">Global Site Building</strong>
                <p class="cont-desc">WSG에 맞춰 현대자동차그룹의 아이덴티티를 유지하면서 <span>각 나라별 니즈를 반영하여 현지 사정에 맞게 최적화된 디자인으로 작업 했습니다.</span></p>
            </div>
            <div class="img">
                <img src="" alt="" data-src="/static/img/project-detail/hos/global-site-building@m.png">
            </div>
            <p class="master-platform">Master Platform Australia, Singapore</p>
        </section>
        <section class="section style">
            <div class="inner-section">
                <div class="point-font-area">
                    <div class="img">
                        <img src="" alt="" data-src="/static/img/project-detail/hos/point-font01@m.png">
                    </div>
                    <div class="img">
                        <img src="" alt="" data-src="/static/img/project-detail/hos/point-font02@m.png">
                    </div>
                </div>
                <div class="point-color-area">
                    <ul>
                        <li class="item01"><div>#00aad2</div></li>
                        <li class="item02"><div>#002c5f</div></li>
                        <li class="item03"><div>#e4dcd3</div></li>
                        <li class="item04"><div>#666666</div></li>
                        <li class="item05"><div>#000000</div></li>
                        <li class="item06"><div>#e63312</div></li>
                    </ul>
                </div>
                <div class="point-icon-area">
                    <div class="img">
                        <img src="" alt="" data-src="/static/img/project-detail/hos/point-icon@m.png">
                    </div>
                </div>
            </div>
        </section>
        <!-- Details [e] -->
        <section class="project-client"><strong class="a11y-hidden">Hyundai</strong></section>
        <!-- Page Contents -->
    </div>

    
    <app-pjmove></app-pjmove>
</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var swiper = new Swiper(".pc-web .swiper-container", {
			speed: 400,
			loop: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		});
	},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/swiper.min.css"; /* if use swiper.min.js */
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/hos/ci.png) 50% / auto 27.5px
		no-repeat;
}
.project-visual .project-tit br {
	display: none;
}
.project-visual .project-tit .break-m {
	display: block;
}
.project-visual .project-tit + .link {
	margin-top: 30px;
}
.project-visual {
	background-image: url(/static/img/project-detail/hos/bg-overview@m.jpg);
}

@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hos/bg-overview@t.jpg);
	}
	.project-visual .project-tit .txt-wrap {
		display: block;
	}
	.project-visual .project-tit .txt-wrap .break-m {
		display: inline-block;
		width: auto;
	}
	.project-visual .project-tit .hmc {
		width: 100%;
	}
	.project-client {
		background-size: auto 71px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hos/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 71px;
	}
}

/* project-overview */
.project-overview {
	background-color: #002c5f;
}
.project-overview .project-overview-tit,
.project-overview .project-overview-txt {
	color: #fff;
}
.project-overview .project-overview-txt br {
	display: none;
}
.project-overview .project-overview-diagram {
	margin-top: 42px;
	color: #fff;
}
.project-overview .project-overview-diagram .diagram01 {
	padding-bottom: 52px;
	text-align: center;
}
.project-overview .project-overview-diagram .diagram02 ul {
	position: relative;
	width: 269px;
	height: 252px;
	margin: 0 auto;
}
.project-overview .project-overview-diagram .diagram02 ul::before {
	content: "";
	position: absolute;
	top: -30px;
	left: 50%;
	width: 15px;
	height: 15px;
	margin: -7px 0 0 -7px;
	border: 1px solid #fff;
	border-width: 0 0 1px 1px;
	transform: rotate(-45deg);
}
.project-overview .project-overview-diagram .diagram02 ul li {
	display: flex;
	position: absolute;
	width: 138px;
	height: 138px;
	border: 1px solid #fff;
	border-radius: 50%;
	text-align: center;
	justify-content: center;
	align-items: center;
}
.project-overview .project-overview-diagram .diagram02 ul li:nth-child(1) {
	top: 0;
	left: 0;
}
.project-overview .project-overview-diagram .diagram02 ul li:nth-child(2) {
	top: 0;
	right: 0;
}
.project-overview .project-overview-diagram .diagram02 ul li:nth-child(3) {
	top: 113px;
	left: 65px;
}
.project-overview .project-overview-diagram .diagram03 {
	position: relative;
	padding-top: 68px;
	text-align: center;
}
.project-overview .project-overview-diagram .diagram03::before {
	content: "";
	position: absolute;
	top: 20px;
	left: 50%;
	width: 1px;
	height: 30px;
	margin-left: -1px;
	background-color: #fff;
}
.project-overview .project-overview-diagram .diagram03 span {
	display: block;
	margin-top: 6px;
	font-size: 1.3rem;
}

/* master-platform */
.layer-project-detail > section.master-platform {
	padding: 0;
}
.master-platform {
	position: relative;
	padding: 0;
}
.master-platform .inner-section {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;
	padding: 40px 15px;
	color: #fff;
}
.master-platform .project-subtit {
	font-weight: 300;
}
.master-platform .project-subtit strong {
	display: block;
}
.master-platform .img img {
	width: 100%;
}

/* pc-web */
.pc-web {
	position: relative;
}
.pc-web .inner-section {
	position: relative;
	z-index: 10;
}
.pc-web::before {
	content: "";
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	height: calc(106px + 19.8%);
	background-color: #e6ddd5;
}
.pc-web .img {
	margin: 30px -15px 0;
}
.pc-web .img img {
	width: 100%;
}
.pc-web .swiper-wrap {
	margin: 0 -15px;
}
.pc-web .swiper-wrap .swiper-container {
	padding-bottom: 60px;
}
.pc-web .swiper-wrap .swiper-container .swiper-slide > div {
	margin: 0 60px;
	box-shadow: 0px 17px 20px 0px rgba(0, 0, 0, 0.22);
}
.pc-web .swiper-wrap img {
	display: block;
	width: 100%;
}
.pc-web .cont-desc br {
	display: none;
}

/* tablet-web */
.tablet-web {
	position: relative;
}
.tablet-web::before {
	content: "";
	position: absolute;
	top: 21px;
	right: 15px;
	left: 15px;
	height: 1px;
	background-color: #dadbdc;
}
.tablet-web .inner-section {
	position: relative;
	padding: 0 20px;
}
.tablet-web .inner-section::before {
	content: "";
	position: absolute;
	top: -18px;
	left: 0;
	bottom: 0;
	width: 1px;
	background-color: #dadbdc;
}
.tablet-web .inner-section::after {
	content: "";
	position: absolute;
	top: -18px;
	right: 0;
	bottom: 0;
	width: 1px;
	background-color: #dadbdc;
}
.tablet-web .img-area {
	position: relative;
	padding-top: 30px;
}
.tablet-web .img-area::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 1px;
	height: 40%;
	background-color: #dadbdc;
}
.tablet-web .img-area::after {
	content: "";
	position: absolute;
	top: 0;
	right: 0;
	width: 1px;
	height: 40%;
	background-color: #dadbdc;
}
.tablet-web .img {
	position: relative;
}
.tablet-web .img img {
	position: relative;
	z-index: 10;
	width: 100%;
}
.tablet-web .img::before {
	content: "";
	position: absolute;
	top: calc(40% - 19px);
	left: 0;
	width: 8%;
	height: 1px;
	background-color: #dadbdc;
}
.tablet-web .img::after {
	content: "";
	position: absolute;
	top: calc(40% - 19px);
	right: 0;
	width: 8%;
	height: 1px;
	background-color: #dadbdc;
}
.tablet-web .cont-desc br {
	display: none;
}

/* mobile-web */
.mobile-web .cont-desc br {
	display: none;
}
.mobile-web .img {
	padding: 45px 0 0;
}
.mobile-web .img img {
	width: 100%;
}

/* global-site-building */
.global-site-building {
	position: relative;
	background-color: #222;
}
.global-site-building::after {
	content: "";
	position: absolute;
	left: 50%;
	bottom: -50px;
	width: 1px;
	height: 100px;
	margin-left: -1px;
	background-color: #00a9d2;
}
.global-site-building .project-subtit {
	color: #fff;
}
.global-site-building .cont-desc {
	color: #fff;
}
.global-site-building .img {
	padding: 25px 0;
}
.global-site-building .img img {
	width: 100%;
}
.global-site-building .master-platform {
	padding-bottom: 20px;
	font-size: 1.4rem;
	color: #00aad2;
	text-align: center;
}

/* style */
.style {
	padding: 100px 15px 50px;
	background-color: #f1f2f5;
}
.style .point-font-area .img {
	width: 290px;
}
.style .point-font-area .img + .img {
	margin-top: 24px;
}
.style .point-color-area {
	max-width: 290px;
	margin: 30px auto 0;
}
.style .point-color-area ul {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
}
.style .point-color-area ul li {
	margin-top: 15px;
	margin-left: 16px;
}
.style .point-color-area ul li > div {
	position: relative;
	width: 86px;
	height: 86px;
	padding: 34px 5px;
	text-align: center;
	font-size: 1.4rem;
	color: #fff;
	line-height: 18px;
}
.style .point-color-area ul li:nth-child(1),
.style .point-color-area ul li:nth-child(4) {
	margin-left: 0;
}
.style .point-color-area ul li:nth-child(3) > div {
	color: #000;
}
.style .point-color-area .item01 > div {
	background-color: #00aad2;
}
.style .point-color-area .item02 > div {
	background-color: #002c5f;
}
.style .point-color-area .item03 > div {
	background-color: #e4dcd3;
}
.style .point-color-area .item04 > div {
	background-color: #666666;
}
.style .point-color-area .item05 > div {
	background-color: #000000;
}
.style .point-color-area .item06 > div {
	background-color: #e63312;
}
.style .point-color-area ul li span {
	display: block;
}
.style .point-icon-area {
	max-width: 290px;
	margin: 30px auto 0;
}

/* Detail */
@media screen and (min-width: 712px) {
	.project-visual .project-tit + .link {
		font-size: 1.9662vw;
	}

	/* project-overview */
	.project-overview .project-overview-diagram {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 40px 0;
	}
	.project-overview .project-overview-diagram .diagram01 {
		padding: 0 35px 0 0;
	}
	.project-overview .project-overview-diagram .diagram02 ul {
		width: 331px;
		height: auto;
	}
	.project-overview .project-overview-diagram .diagram02 ul::before {
		top: 50%;
		left: -26px;
		width: 20px;
		height: 20px;
		margin-top: -10px;
		transform: rotate(-135deg);
	}
	.project-overview .project-overview-diagram .diagram02 ul::after {
		content: "";
		display: block;
		clear: both;
	}
	.project-overview .project-overview-diagram .diagram02 ul li {
		position: relative;
		top: auto;
		right: auto;
		left: auto;
		float: left;
		width: 115px;
		height: 115px;
	}
	.project-overview .project-overview-diagram .diagram02 ul li:nth-child(3) {
		top: auto;
		left: auto;
	}
	.project-overview .project-overview-diagram .diagram02 ul li + li {
		margin-left: -7px;
	}
	.project-overview .project-overview-diagram .diagram03 {
		padding: 0 0 0 40px;
	}
	.project-overview .project-overview-diagram .diagram03::before {
		top: 50%;
		left: 9px;
		width: 30px;
		height: 1px;
		margin-top: -1px;
	}

	/* master-platform */
	.master-platform {
		position: relative;
		padding: 0;
	}
	.master-platform .inner-section {
		top: 50%;
		left: 0;
		margin-top: -60px;
		padding: 0 40px;
	}
	.master-platform .project-subtit {
		font-weight: 300;
		line-height: 1.3;
	}
	.master-platform .project-subtit br {
		display: none;
	}
	.master-platform .project-subtit strong {
		display: block;
	}
	.master-platform .img img {
		width: 100%;
	}

	/* pc-web */
	.pc-web::before {
		height: calc(85px + 21%);
	}
	.pc-web .img {
		margin: 30px -5.7vw 50px;
	}
	.pc-web .swiper-wrap {
		margin: 0 -40px;
	}
	.pc-web .swiper-wrap .swiper-container {
		padding-bottom: 80px;
	}
	.pc-web .swiper-wrap .swiper-container .swiper-slide > div {
		margin: 0 21vw;
	}
	.pc-web .cont-desc br {
		display: block;
	}

	/* tablet-web */
	.tablet-web::before {
		right: 40px;
		left: 40px;
	}
	.tablet-web .cont-desc br {
		display: block;
	}
	.tablet-web .cont-desc span {
		display: block;
	}
	.tablet-web .img-area::before,
	.tablet-web .img-area::after {
		height: 87%;
	}
	.tablet-web .img::before {
		top: calc(87% - 5px);
		left: 5.8vw;
		width: 60%;
	}
	.tablet-web .img::after {
		top: calc(87% - 5px);
		right: 5.8vw;
	}
	.tablet-web .img {
		margin: 0 -5.7vw;
	}
	.tablet-web .img::after {
		content: none;
	}

	/* mobile-web */
	.mobile-web .project-subtit,
	.mobile-web .cont-desc {
		text-align: center;
	}
	.mobile-web .cont-desc br {
		display: block;
	}
	.mobile-web .img {
		margin: 0 -5.7vw;
	}

	/* global-site-building */
	.global-site-building {
		position: relative;
		background-color: #222;
	}
	.global-site-building::after {
		content: "";
		position: absolute;
		left: 50%;
		bottom: -50px;
		height: 100px;
		margin-left: -1px;
		background-color: #00a9d2;
	}
	.global-site-building .project-subtit,
	.global-site-building .cont-desc {
		text-align: center;
	}
	.global-site-building .cont-desc span {
		display: block;
	}
	.global-site-building .img {
		margin: 0 -40px;
	}
	.global-site-building .img img {
		width: 100%;
	}
	.global-site-building .master-platform {
		padding-bottom: 20px;
		font-size: 1.4rem;
		color: #00aad2;
		text-align: center;
	}

	/* style */
	.style {
		padding-bottom: 80px;
	}
	.style .inner-section {
		padding: 0 28px;
	}
	.style .point-font-area {
		display: flex;
	}
	.style .point-font-area .img {
		flex: 1;
		text-align: center;
	}
	.style .point-font-area .img:nth-child(1) img {
		width: 264px;
	}
	.style .point-font-area .img:nth-child(2) img {
		width: 246px;
	}
	.style .point-font-area .img + .img {
		margin: 0 0 0 60px;
	}
	.style .point-color-area {
		display: flex;
		max-width: 1080px;
		justify-content: center;
	}
	.style .point-color-area ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin: 0 -25px;
	}
	.style .point-color-area ul li {
		margin: 0;
		padding: 10px 25px;
	}
	.style .point-color-area ul li:nth-child(1),
	.style .point-color-area ul li:nth-child(4) {
		margin: 0;
	}
	.style .point-icon-area {
		max-width: 1080px;
	}
}

@media screen and (min-width: 1280px) {
	.project-visual .project-tit + .link {
		margin-top: 60px;
		font-size: 2rem;
	}
	.cont-desc {
		font-size: 16px;
		line-height: 1.8;
	}

	/* project-overview */
	.project-overview .project-overview-diagram {
		margin: 50px 0 20px;
	}
	.project-overview .project-overview-diagram .diagram01 {
		padding-right: 116px;
		font-size: 20px;
	}
	.project-overview .project-overview-diagram .diagram02 ul {
		width: 662px;
	}
	.project-overview .project-overview-diagram .diagram02 ul::before {
		left: -86px;
		width: 40px;
		height: 40px;
		margin-top: -19px;
		border-width: 0 0 2px 2px;
	}
	.project-overview .project-overview-diagram .diagram02 ul li {
		width: 230px;
		height: 230px;
		font-size: 20px;
		border-width: 2px;
	}
	.project-overview .project-overview-diagram .diagram02 ul li + li {
		margin-left: -14px;
	}
	.project-overview .project-overview-diagram .diagram03 {
		padding-left: 146px;
		font-size: 20px;
	}
	.project-overview .project-overview-diagram .diagram03::before {
		left: 40px;
		width: 80px;
		height: 2px;
	}
	.project-overview .project-overview-diagram .diagram03 span {
		font-size: 18px;
	}

	/* master-platform */
	.master-platform .inner-section {
		left: 50%;
		padding-left: 0;
		margin-top: -100px;
		margin-left: -620px;
	}
	.master-platform .project-subtit {
		margin-bottom: 34px;
		font-size: 60px;
		line-height: 1.2;
	}

	/* pc-web */
	.pc-web::before {
		height: 750px;
	}
	.pc-web .cont {
		padding-bottom: 120px;
	}
	.pc-web .img {
		margin: 35px -34px 50px;
	}
	.pc-web .swiper-wrap .swiper-container .swiper-slide > div {
		width: 864px;
		margin: 0 auto;
		box-shadow: 0px 33px 40px 0px rgba(0, 0, 0, 0.22);
	}
	.pc-web .cont-desc br {
		display: none;
	}

	/* tablet-web */
	.tablet-web {
		min-height: 1190px;
	}
	.tablet-web .project-subtit {
		padding-top: 50px;
	}
	.tablet-web .project-subtit,
	.tablet-web .cont-desc {
		padding-left: 100px;
	}
	.tablet-web .cont-desc span {
		display: block;
	}
	.tablet-web::before {
		left: 50%;
		width: 1240px;
		margin-left: -620px;
	}
	.tablet-web .inner-section::before,
	.tablet-web .inner-section::after {
		content: none;
	}
	.tablet-web .img-area {
		padding-bottom: 250px;
	}
	.tablet-web .img-area::before {
		content: none;
	}
	.tablet-web .img::before {
		top: 1086px;
		left: 50%;
		margin-left: -620px;
	}
	.tablet-web .img::after {
		content: "";
		top: 104px;
		right: auto;
		left: 50%;
		width: 1px;
		height: 983px;
		margin-left: -620px;
	}
	.tablet-web .img {
		margin: 0;
	}
	.tablet-web .img-area {
		position: absolute;
		top: -82px;
		left: 50%;
		width: 1658px;
		margin-left: -829px;
		padding-top: 0;
	}
	.tablet-web .img-area::after {
		content: none;
	}

	/* mobile-web */
	.mobile-web .img {
		max-width: 1240px;
		margin: 0 auto;
		padding-top: 50px;
	}

	/* global-site-building */
	.global-site-building .inner-section {
		padding-top: 40px;
	}
	.global-site-building::after {
		bottom: -100px;
		width: 2px;
		height: 200px;
	}
	.global-site-building .img {
		width: 1240px;
		margin: 0 auto;
		padding: 50px 0;
	}
	.global-site-building .master-platform {
		padding-bottom: 120px;
		font-size: 20px;
	}

	/* style */
	.style {
		padding-top: 160px;
		padding-bottom: 160px;
	}
	.style .point-icon-area {
		margin: 50px auto 0;
	}
	.style .point-font-area .img:nth-child(1) {
		padding-left: 36px;
	}
	.style .point-font-area .img:nth-child(1) img,
	.style .point-font-area .img:nth-child(2) img {
		width: auto;
	}
	.style .point-color-area {
		margin-top: 50px;
	}
	.style .point-color-area ul li {
		padding: 10px 0;
	}
	.style .point-color-area ul li + li {
		margin-left: 90px;
	}
	.style .point-color-area ul li:nth-child(4),
	.style .point-color-area ul li:nth-child(5),
	.style .point-color-area ul li:nth-child(6) {
		margin-left: 88px;
	}
	.style .point-color-area ul li > div {
		width: 106px;
		height: 106px;
		line-height: 34px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/hos.vue